/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconGuanbi1: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M512 400.896L890.1632 22.784a77.6704 77.6704 0 0 1 109.824 0l1.3312 1.1776c30.208 30.3616 30.208 79.5648 0 109.9776L623.1552 512l378.1632 378.112a77.824 77.824 0 0 1 0 109.824l-1.3312 1.28a77.7216 77.7216 0 0 1-109.824 0L512 623.1552l-378.1632 378.112a77.824 77.824 0 0 1-109.8752 0l-1.2288-1.28a77.6704 77.6704 0 0 1 0-109.824L400.896 512 22.7328 133.9392a77.824 77.824 0 0 1 0-109.9776L23.9616 22.784a77.7216 77.7216 0 0 1 109.8752 0L512 400.896z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </svg>
  );
};

IconGuanbi1.defaultProps = {
  size: 18,
};

export default IconGuanbi1;
